import { useFetchOrganizationLimit } from '@uturn/api/v3';
import { MetaDataContext } from '@uturn/portal/context';
import { useContext } from 'react';
import { REFETCH_CREDIT_USAGE_INTERVAL } from '../modules/shipments/utils/credit-limit-banner';

export const useOrganizationCreditLimit = () => {
	const { metadata } = useContext(MetaDataContext);
	const orgId = metadata?.user?.organisation?.id ?? 0;

	const hasOrg = orgId > 0;

	const { data: limits } = useFetchOrganizationLimit(orgId, {
		query: {
			select: (d) => d.data,
			refetchInterval: REFETCH_CREDIT_USAGE_INTERVAL,
			enabled: hasOrg,
		},
	});

	const fullLimitReached = Boolean(limits?.fullLimitReached);

	return { fullLimitReached, limits, hasOrg };
};
